let theme = {
  primary: '#1F9090',
}

export default theme
